<template>
  <v-container fluid>
    <wholeSale :StoreInfo="UserInfo" BranchColor="primary darken-3"></wholeSale>
  </v-container>
</template>
<script>
import { tokenMixin } from "@/Mixins/tokenMixins.js";
import { mapGetters } from "vuex";
export default {
  components: {
    wholeSale: () => import("@/components/Branches/Sales/StoreItems"),
  },
  props: {
    // User: [Object]
  },
  mixins: [tokenMixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getProducts"]),
    BranchColor() {
      return this.User.BranchType == "store"
        ? "primary darken-3"
        : "teal darken-3";
    },
    isStore() {
      return this.User.BranchType == "store";
    },
  },

  created() {
    if (!this.getProducts.length) this.$store.dispatch("LoadProdacts");
    // console.log(this.getProducts.length);
    // this.loadProducts();
  },
};
</script>
